import React from "react";
import { tryFormatDetailDateTime } from "Utils/utils";
import { formatAuditFieldName } from "./auditFieldLabels";
import useCareSector from "hooks/useCareSector";

const SnapshotView = ({ snapshot, relatedCounts }) => {
  const { careSector } = useCareSector();
  if (!snapshot || Object.keys(snapshot).length === 0) return null;

  const formatValue = (val, field) => {
    if (val === null || val === undefined)
      return <span className="text-gray-400 italic">empty</span>;
    const dateFormatted = tryFormatDetailDateTime(val, field);
    if (dateFormatted !== null) return dateFormatted;
    if (typeof val === "object") return JSON.stringify(val);
    return String(val);
  };

  return (
    <div className="mt-2">
      <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-2">
        <p className="text-xs text-red-600 font-medium mb-2">
          This record no longer exists. Below is a snapshot from before
          deletion.
        </p>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          {Object.entries(snapshot).map(([field, val]) => (
            <div key={field} className="flex">
              <span className="text-xs font-medium text-gray-500 min-w-[100px]">
                {formatAuditFieldName(field, careSector)}:
              </span>
              <span className="text-xs text-gray-800 ml-1">
                {formatValue(val, field)}
              </span>
            </div>
          ))}
        </div>
      </div>
      {relatedCounts && Object.keys(relatedCounts).length > 0 && (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-3">
          <p className="text-xs text-gray-600 font-medium mb-1">
            Related data also deleted:
          </p>
          <div className="flex flex-wrap gap-3">
            {Object.entries(relatedCounts).map(([key, count]) => (
              <span key={key} className="text-xs text-gray-500">
                {formatAuditFieldName(key, careSector)}: <strong>{count}</strong>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SnapshotView;
